import React from 'react'

export default ({list, active, onClick}) => {
    
    return (
         /* 
            <div className='step'>
                <div className='node-step active'>
                    <span className='index'>1</span>
                    <span className='title'>No. Ponsel</span>
                </div>
                <hr />
                <div className='node-step'>
                    <span className='index'>2</span>
                    <span className='title'>OTP</span>
                </div>
                <hr />
                <div className='node-step'>
                    <span className='index'>3</span>
                    <span className='title'>Surel</span>
                </div>
            </div> 
        */
       <div className='steps'>
            <ul className='info'>
                <li>{active+1}</li>
                <li>dari</li>
                <li>{list.length}</li>
            </ul>

            <ul className='node'>
                {list.map((item, index) =>  <li className={index < active ? 'done' : index === active ? 'active' : ''} key={index} title={item} onClick={() => onClick(index)}></li>)}
            </ul>
       </div>
    )
}
